import { useNavigate } from 'react-router-dom';
import { SessionTimeout } from '@socialgoodsoftware/components';
import { subscribeToSessionActivity } from '@socialgoodsoftware/components';

function SessionTimeoutWatcher() {
  const navigate = useNavigate();

  const signOut = () => {
    navigate('/logout', { replace: true });
  };

  return <SessionTimeout onExpired={signOut} subscribeToActivity={subscribeToSessionActivity} />;
}

export { SessionTimeoutWatcher };
